export const PORTFOLIO_VIEWS = {
    csm: "csm",
    sales: "sales",
    all: "all",
};

export const HEALTH_LEVELS = {
    green: { label: "Saudável", color: "success", icon: "mdi-heart-pulse" },
    yellow: { label: "Atenção", color: "warning", icon: "mdi-alert-outline" },
    red: { label: "Risco", color: "danger", icon: "mdi-alert-circle-outline" },
};

export const BILLING_STATUS_LABELS = {
    active: { label: "Ativo", color: "success" },
    trial_started: { label: "Trial", color: "accent" },
    past_due: { label: "Inadimplente", color: "danger" },
    expired: { label: "Expirado", color: "muted" },
    cancelled: { label: "Cancelado", color: "muted" },
};

export const TRANSFER_REASONS = [
    { value: "resignation", label: "Desligamento do colaborador" },
    { value: "reassignment", label: "Redistribuição de carteira" },
    { value: "workload", label: "Sobrecarga / reequilíbrio" },
    { value: "client_request", label: "Solicitação do cliente" },
    { value: "other", label: "Outro motivo" },
];

export const MANAGER_ROLES = ["owner", "admin"];
